/**
 * Локальное хранилище фронта: токен и базовый URL backend.
 * Account-scoped кэш чатов добавим на этапе 5.6.
 */

const KEY_TOKEN = "aicores.token";
const KEY_BASE_URL = "aicores.baseUrl";
const KEY_PROFILE = "aicores.profile";
const KEY_ACTIVE_CHAT = "aicores.activeChatId";

export function getBaseUrl(): string {
  if (typeof window === "undefined") return "";
  const saved = localStorage.getItem(KEY_BASE_URL);
  if (saved && saved.trim()) return saved.replace(/\/+$/, "");
  // Дефолт: тот же origin (nginx маршрутизирует). В dev Vite proxy → :15581.
  return window.location.origin.replace(/\/+$/, "");
}

export function setBaseUrl(value: string): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY_BASE_URL, value.replace(/\/+$/, ""));
}

export function getToken(): string {
  if (typeof window === "undefined") return "";
  return localStorage.getItem(KEY_TOKEN) || "";
}

export function setToken(value: string): void {
  if (typeof window === "undefined") return;
  if (value) localStorage.setItem(KEY_TOKEN, value);
  else localStorage.removeItem(KEY_TOKEN);
}

export function clearToken(): void {
  setToken("");
}

export function getProfile<T = unknown>(): T | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(KEY_PROFILE);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function setProfile(value: unknown): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY_PROFILE, JSON.stringify(value));
}

export function getActiveChatId(): string {
  if (typeof window === "undefined") return "";
  return localStorage.getItem(KEY_ACTIVE_CHAT) || "";
}

export function setActiveChatId(id: string): void {
  if (typeof window === "undefined") return;
  if (id) localStorage.setItem(KEY_ACTIVE_CHAT, id);
  else localStorage.removeItem(KEY_ACTIVE_CHAT);
}
